export default __webpack_public_path__ + "static/media/baby party 1.826fd363.png";